import "./App.css";
import { useEffect, useState } from "react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Vessel from "./components/Vessel";
import Gallery from "./components/Gallery";
import Species from "./components/Species";
import Booking from "./components/Booking";
import Amenities from "./components/Amenities";
import Reviews from "./components/Reviews";
import Crew from "./components/Crew";
import Location from "./components/Location";
import LookupBar from "./components/LookupBar";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminApp from "./admin/AdminApp";

// Simple pathname switch — no react-router dependency.
// /admin and /admin/* → operator dashboard.
function isAdminPath() {
  if (typeof window === "undefined") return false;
  const p = window.location.pathname || "/";
  return p === "/admin" || p.startsWith("/admin/");
}

export default function App() {
  const [adminMode, setAdminMode] = useState(isAdminPath());

  useEffect(() => {
    const onPop = () => setAdminMode(isAdminPath());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  if (adminMode) return <AdminApp />;

  return (
    <div data-testid="aquarius-app" style={{ background: "var(--aq-foam)" }}>
      <Nav />
      <Hero />
      <Vessel />
      <Species />
      <Gallery />
      <Booking />
      <Amenities />
      <Reviews />
      <Crew />
      <Location />
      <LookupBar />
      <Contact />
      <Footer />
    </div>
  );
}
